import { useState } from 'react';

import { useFamilies, type FamilyRow } from '../../hooks/useFamilies';

import { DataTable } from '@/components/common/DataTable';
import { PageHeader } from '@/components/common/PageHeader';
import { SearchBar } from '@/components/common/SearchBar';
import { AppShell } from '@/components/layout/AppShell';
import { TopBar } from '@/components/layout/TopBar';
import { useNavigate } from '@/lib/router';

function formatDate(dateStr: string) {
  return new Date(dateStr).toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function FamiliesPage() {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const { data = [], isLoading } = useFamilies(search);

  const filtered = search
    ? data.filter((f) => f.name.toLowerCase().includes(search.toLowerCase()))
    : data;

  const columns = [
    {
      key: 'name',
      header: 'Famille',
      cell: (row: FamilyRow) => <span className="font-medium text-slate-900">{row.name}</span>,
    },
    {
      key: 'created_at',
      header: 'Créée le',
      className: 'hidden md:table-cell',
      cell: (row: FamilyRow) => (
        <span className="text-slate-500">{formatDate(row.created_at)}</span>
      ),
    },
    {
      key: 'actions',
      header: '',
      cell: (row: FamilyRow) => (
        <button
          onClick={() => void navigate({ to: `/families/${row.id}` })}
          className="text-sm text-green-600 hover:text-green-700"
        >
          Voir →
        </button>
      ),
    },
  ];

  return (
    <AppShell>
      <TopBar
        title="Familles"
        subtitle={`${filtered.length} famille${filtered.length > 1 ? 's' : ''}`}
      />
      <div className="p-4 md:p-6">
        <PageHeader title="Gestion des familles" />
        <div className="mb-4">
          <SearchBar value={search} onChange={setSearch} placeholder="Rechercher une famille..." />
        </div>
        <DataTable
          data={filtered}
          columns={columns}
          isLoading={isLoading}
          getRowKey={(r) => r.id}
          emptyMessage="Aucune famille trouvée"
        />
      </div>
    </AppShell>
  );
}
